import styled, { css } from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'
import Clickable from 'components/Common/Clickable'

export const activeStyle = css`
  color: ${props => props.theme.palette.neutral.surface.normalContrast};
  background-color: ${props => props.theme.palette.brand.primary.normal};

  &,
  &:hover,
  &:active,
  &:focus {
    color: ${props => props.theme.palette.neutral.surface.normalContrast};
    background-color: ${props => props.theme.palette.brand.primary.normal};
  }

  &::after {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 100%;
    border: ${rem(12)} solid transparent;
    border-top: ${rem(10)} solid ${props => props.theme.palette.brand.primary.normal};
    border-bottom: 0;
    content: "";
  }
`

const OfferNavItem = styled(Clickable)<{ active?: boolean }>`
  padding: ${rem(16)};
  border-left: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  font-weight: ${props => props.theme.font.primary.weight.bold};
  position: relative;
  transition: background-color 0.2s, color 0.2s;

  ${mediaQueryUp.tablet} {
    min-width: ${rem(153)};
  }

  &,
  &:active,
  &:focus {
    color: ${props => props.theme.palette.brand.primary.normal};
    background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  }

  &:hover {
    background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
    color: ${props => props.theme.palette.brand.primary.normal};
  }

  &:last-of-type {
    border-right: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  }

  ${({ active }) => active && activeStyle}
`

export default OfferNavItem
